import classnames from 'classnames'
import Icon from '@components/Icon'
import Button from '@components/Button'
import styles from './styles.module.scss'

export const CardSectionButton = ({ onClick, value, description, isSpecialValue, isSelected, className }) => (
    <Button
        onClick={onClick}
        btnStyle="outline"
        type="button"
        className={classnames('d-flex', 'flex-column', 'ml-2', 'p-2', 'mb-3', styles.sectionButton, {
            [styles.selected]: isSelected,
            [styles.selectedSpecial]: isSpecialValue,
            [className]: !!className,
        })}>
        <div className="d-flex align-items-center">
            <span className="font-weight-bold text-left mb-1">{value}</span>
            {isSelected && (
                <Icon
                    className={classnames('ml-2', styles.checkIcon, {
                        [styles.isSpecial]: isSpecialValue,
                    })}
                    type="checked_new"
                />
            )}
        </div>
        <span className="text-light text-small text-lowercase">{description}</span>
    </Button>
)

CardSectionButton.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.string.isRequired,
    description: PropTypes.string,
    isSpecialValue: PropTypes.bool,
    isSelected: PropTypes.bool,
}
